import httpClient from '@/apis/base/httpclient';
import DIApi from './_diApi';

class DbOptionApi extends DIApi {
  controllerName = 'dboptions';

  /**
   * Lấy dữ liệu danh sách dữ liệu dbOption
   * HQMINH 13.04.2023
   */
  async getDbOptions() {
    const request = {
      url: this.getAPIUrl() + '/',
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu danh sách dữ liệu dbOption theo key
   * HQMINH 04.05.2023
   * @param {*} payload
   * @returns
   */
  async getDbOptionByKeys(payload) {
    const request = {
      url: this.getAPIUrl() + '/dbOptionByKeys',
      data: {keys: payload},
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Lấy dbOption theo key, đọc TRỰC TIẾP từ bảng (không qua cache) — dùng khi cần giá trị mới nhất
   * ntchuyen 04.09.2026
   * @param {*} payload
   * @returns
   */
  async getKeysFromDb(payload) {
    const request = {
      url: this.getAPIUrl() + '/get-keys-from-db',
      data: {keys: payload},
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Cập nhập dbOption
   * HQMINH 04.05.2023
   * @param {*} payload
   * @returns
   */
  async updateDbOptions(payload) {
    const request = {
      url: this.getAPIUrl() + '/Update',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * insert dboption, nếu có thì update
   * tvtoan - 02/01/2024
   * @param {*} payload
   * @returns
   */
   async insertUpdateDbOptions(payload) {
    const request = {
      url: this.getAPIUrl() + '/InsertUpdate',
      data: payload,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu danh sách dbOption theo database_id
   * TVTOAN 12.01.2024
   * @param {*} payload
   * @returns
   */
   async getDbOptionByDatabaseId(databaseId) {
    const request = {
      url: [
        this.getAPIUrl(),
        '/dbOptionByDatabaseId',`?databaseId=${databaseId}`,
      ].join(''),
    };
    return await httpClient.getAsync(request);
  }

}

export default new DbOptionApi();
